import {IabCategoryBean} from 'common/api/api'
import {useAppContext} from 'common/context/AppContext'
import {showError} from 'common/util/Util'
import {TreeSelect} from 'antd'
import {dictionaryApi} from 'common/api/entitiesApi'
import React, {FC, useEffect, useState} from 'react'

let IAB_CATEGORIES_DATA: Array<TreeSelectData> | undefined

interface TreeSelectData {
    title: string,
    value: number,
    key: number,
    children?: TreeSelectData[]
}

interface Props {
    value?: string
    onChange?: (value: any) => void
    style?: React.CSSProperties
    disabled?: boolean
    placeholder?: string
}

export const IABCategoriesSelector: FC<Props> = (
    {value, onChange, style, disabled, placeholder}
) => {
    const [treeData, setTreeData] = useState<any>([])
    const [loading, setLoading] = useState<boolean>(false)
    const appContext = useAppContext()

    useEffect(() => {
        if (IAB_CATEGORIES_DATA) {
            setTreeData(IAB_CATEGORIES_DATA)
        } else {
            setLoading(true)
            dictionaryApi.iabCategories()
                .then(iabCategories => {
                    const newTreeData = getIabCategoriesAsTree(iabCategories)
                    setTreeData(newTreeData)
                    IAB_CATEGORIES_DATA = newTreeData
                    setLoading(false)
                })
                .catch(e => {
                    setTreeData([])
                    IAB_CATEGORIES_DATA = []
                    showError(appContext, e)
                    setLoading(false)
                })
        }
    }, [])

    function getIabCategoriesAsTree(list: IabCategoryBean[]) {
        let root: TreeSelectData[] = []
        list.filter(v => v.parentId == null)
            .forEach(v => v.name && v.id && root.push({
                title: `${v.code} ${v.name}`,
                key: v.id,
                value: v.id,
                children: []
            }))
        list.filter(v => v.parentId != null)
            .forEach(v => {
                let group = root.find(item => item.value === v.parentId)
                if (group != undefined && group.children != undefined) {
                    v.name && v.id && group.children.push({
                        title: `${v.code} ${v.name}`,
                        key: v.id,
                        value: v.id
                    })
                }
            })
        return root
    }

    const onChangeInternal = (value) => {
        onChange && onChange(value && value.map(elem => elem.value))
    }

    return <TreeSelect
        loading={loading}
        value={value}
        showSearch
        treeNodeFilterProp="title"
        allowClear
        treeCheckable
        showCheckedStrategy="SHOW_ALL"
        treeCheckStrictly
        placement={'topRight'}
        style={style}
        placeholder={placeholder}
        disabled={disabled}
        onChange={onChangeInternal}
        treeData={treeData}
    />
}